( function() {
	document.addEventListener( 'DOMContentLoaded', function() {
		const className = document.querySelector( '.find-support-large' );
		const btnEle = className.querySelector( 'button' );
		const videoEle = className.querySelector( 'video' );

		if( btnEle && videoEle ) { init(); }

		function init() {
			const motionReduced = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

			if( motionReduced ){
				btnEle.classList.add( 'find-support-large__pause--paused' );
				videoEle.pause();
			}

			btnEle.addEventListener( 'click', toggleVideo );
		}

		function toggleVideo() {
			let paused = btnEle.classList.contains( 'find-support-large__pause--paused' ) ? true : false;

			if( paused ) {
				btnEle.classList.remove( 'find-support-large__pause--paused' );
				videoEle.play();
			} else {
				btnEle.classList.add( 'find-support-large__pause--paused' );
				videoEle.pause();
			}
		}
	} );
} )();